import {
    FilterData,
    FilterBlockTypesEnum,
    ContentData,
} from "../../src/apis/stateful-content";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const filterData: FilterData = {
    filterBlocks: [
        {
            type: FilterBlockTypesEnum.Dropdown,
            name: "type",
            filterItems: [
                {
                    name: "allTrainings",
                    value: "allTrainings",
                    label: "All Trainings",
                    disabled: false,
                    active: false,
                },
                {
                    name: "consultation",
                    value: "consultation",
                    label: "Consultation",
                    disabled: false,
                    active: false,
                },
                {
                    name: "operator",
                    value: "operator",
                    label: "Operator",
                    disabled: false,
                    active: false,
                },
                {
                    name: "programming",
                    value: "programming",
                    label: "Programming",
                    disabled: false,
                    active: false,
                },
                {
                    name: "maintenance",
                    value: "maintenance",
                    label: "Maintenance",
                    disabled: false,
                    active: false,
                },
                {
                    name: "technologyAdvanced",
                    value: "technologyAdvanced",
                    label: "Technology & advanced trainings",
                    disabled: false,
                    active: false,
                },
                {
                    name: "other",
                    value: "other",
                    label: "Other trainings & courses",
                    disabled: false,
                    active: false,
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Dropdown,
            name: "format",
            filterItems: [
                {
                    name: "allFormats",
                    value: "allFormats",
                    label: "All Formats",
                    disabled: false,
                    active: false,
                },
                {
                    name: "presence",
                    value: "presence",
                    label: "Presence",
                    disabled: false,
                    active: false,
                },
                {
                    name: "online",
                    value: "online",
                    label: "Online",
                    disabled: false,
                    active: false,
                },
                {
                    name: "blendedLearning",
                    value: "blendedLearning",
                    label: "Blended Learning",
                    disabled: false,
                    active: false,
                },
                {
                    name: "eLearning",
                    value: "eLearning",
                    label: "E-Learning",
                    disabled: false,
                    active: false,
                },
                {
                    name: "microtraining",
                    value: "microtraining",
                    label: "Microtraining",
                    disabled: false,
                    active: false,
                },
                {
                    name: "presenceAtClient",
                    value: "presenceAtClient",
                    label: "Presence at Client",
                    disabled: false,
                    active: false,
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Select,
            multiple: false,
            name: "languages",
            options: [
                {
                    label: "English",
                    value: "en",
                    selected: false,
                    disabled: false,
                },
                {
                    label: "German",
                    value: "de",
                    selected: true,
                    disabled: false,
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Dropdown,
            name: "location",
            filterItems: [
                {
                    name: "allLocations",
                    value: "allLocations",
                    label: "All locations",
                    disabled: false,
                    active: true,
                },
                {
                    name: "ditzingen",
                    value: "ditzingen",
                    label: "Ditzingen",
                    disabled: false,
                    active: false,
                },
                {
                    name: "loremIpsum",
                    value: "lorem",
                    label: "Lorem ipsum",
                    disabled: false,
                    active: false,
                },
            ],
        },
    ],
};

const contentData: ContentData = {
    totalCount: 22,
    filteredCount: 22,
    schema: {
        category: {
            order: [1001, 1002, 1003, 1004, 1005],
        },
        isExpanded: [1001],
    },
    items: [
        {
            title: "Bedienerkurs TruArc Weld 1000",
            id: 1153222,
            category: 1001,
            typeId: 1,
            format: "eLearning",
            levels: ["beginner"],
            languages: ["de", "en"],
            description:
                "Sie sind in der Lage die Anlage zu bedienen um Aufträge abzuarbeiten. Sie erwerben die Kenntnisse eigene Schweißversuche an der Anlage durchzuführen, um die Bedienung der TruArc Weld zu festigen.",
            events: [
                {
                    startDate: "2025-01-28 11:44:00",
                    languages: ["de", "en"],
                    duration: "7 Wochen",
                    location: "",
                    availability: 1000,
                    detailsLink: "#",
                },
            ],
        },
        {
            title: "Bedienerkurs TruArc Weld 1000",
            id: 1153222,
            category: 1002,
            typeId: 2,
            format: "presence",
            levels: ["beginner"],
            languages: ["de", "fr", "it"],
            description:
                "Sie sind in der Lage die Anlage zu bedienen um Aufträge abzuarbeiten. Sie erwerben die Kenntnisse eigene Schweißversuche an der Anlage durchzuführen, um die Bedienung der TruArc Weld zu festigen.",
            events: [
                {
                    startDate: "2025-01-28 11:44:00",
                    languages: ["de", "it"],
                    duration: "3 Tage",
                    location: "Global Training Center Ditzingen",
                    availability: 5,
                    detailsLink: "#",
                },
                {
                    startDate: "2025-01-29 12:44:00",
                    languages: ["de", "fr"],
                    duration: "4 Tage",
                    location: "Global Training Center Ditzingen",
                    availability: 10,
                    detailsLink: "#",
                },
                {
                    startDate: "2025-02-01 13:44:00",
                    languages: ["de"],
                    duration: "5 Tage",
                    location: "Global Training Center Ditzingen",
                    availability: 2,
                    detailsLink: "#",
                },
                {
                    startDate: "2025-02-02 14:44:00",
                    languages: ["de", "fr", "it"],
                    duration: "1 Tag",
                    location: "Global Training Center Ditzingen",
                    availability: 0,
                    detailsLink: "#",
                },
            ],
        },
        {
            title: "Bedienerkurs TruArc Weld 1000",
            id: 1153222,
            category: 1002,
            typeId: 2,
            format: "blendedLearning",
            levels: ["beginner", "advanced"],
            languages: ["en"],
            description:
                "Sie sind in der Lage die Anlage zu bedienen um Aufträge abzuarbeiten. Sie erwerben die Kenntnisse eigene Schweißversuche an der Anlage durchzuführen, um die Bedienung der TruArc Weld zu festigen.",
            events: [
                {
                    startDate: "2025-01-28 11:44:00",
                    languages: ["en"],

                    duration: "3 Tage",
                    location: "Global Training Center Ditzingen",
                    availability: 0,
                    detailsLink: "#",
                },
                {
                    startDate: "2025-01-29 12:44:00",
                    languages: ["en"],

                    duration: "4 Tage",
                    location: "Global Training Center Ditzingen",
                    availability: 20,
                    detailsLink: "#",
                },
            ],
        },
        {
            title: "Bedienerkurs TruArc Weld 1000",
            id: 1153222,
            category: 1002,
            typeId: 2,
            levels: ["advanced"],
            languages: ["de", "en"],
            description:
                "Sie sind in der Lage die Anlage zu bedienen um Aufträge abzuarbeiten. Sie erwerben die Kenntnisse eigene Schweißversuche an der Anlage durchzuführen, um die Bedienung der TruArc Weld zu festigen.",
            events: [],
        },
    ],
};

const emptyResponse: ContentData = {
    totalCount: 0,
    filteredCount: 0,
    items: [],
    error: {
        head: " Aktuelle gibt es keine Schulungen für diese Maschine.",
    },
};

const writeToFile = (object: any, name: string) => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(filterData, "mymachine-trainings-filter");
writeToFile(contentData, "mymachine-trainings-content");
writeToFile(emptyResponse, "mymachine-trainings-empty");
